require('./show');

var player;

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        var index = $('.category-item.selected').attr('data-id');
        if (index == '1') {
            getThreads();
        } else if (index == '2') {
            getLives();
        } else if (index == '3') {

        } else if (index == '4') {

        } else if (index == '5') {
            getFollows();
        } else if (index == '6') {
            getFans();
        }
    }
});

$(function () {
    $('.category-item').on('click', function () {
        var index = $(this).attr('data-id');
        if (index == $('.category-item.selected').attr('data-id'))
            return;

        $('.category-item.selected').removeClass('selected');
        $(this).addClass('selected');
        $('.live-list').css('display', 'none');
        $('.community-list').css('display', 'none');
        $('.follow-list').css('display', 'none');
        $('.fan-list').css('display', 'none');

        if (index == '1') {
            getThreads();
            $('.community-list').css('display', 'block');
        } else if (index == '2') {
            getLives();
            $('.live-list').css('display', 'block');
        } else if (index == '3') {
        } else if (index == '4') {
        } else if (index == '5') {
            getFollows();
            $('.follow-list').css('display', 'block');
        } else if (index == '6') {
            getFans();
            $('.fan-list').css('display', 'block');
        }
    });

    $('.category-item[data-id=1]').click();

    $('.user-btn').on('click', function () {
        var type = $(this).attr('datatype');
        if (type == 'logout') {
            location.href = '/user/logout';
        }
    });
});

function getThreads() {
    var page = parseInt($('.community-list').attr('page'));
    var id = $('input[name=personid]').val();
    if(!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/threads?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toThread(data, $('.community-list .communityItems'));

            if (data.data.length < 5)
                $('.community-list .more').addClass('no-more');
            else
                $('.community-list .more').css('display', 'block');

            $('.community-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getLives() {
    var page = parseInt($('.live-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/lives?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toLive(data, $('.live-list .liveItems'), false);

            if (data.data.length < 8)
                $('.live-list .more').addClass('no-more');
            else
                $('.live-list .more').css('display', 'block');

            $('.live-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getFollows() {
    var page = parseInt($('.follow-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/follows?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFollow(data, $('.follow-list .followItems'));

            if (data.data.length < 10)
                $('.follow-list .more').addClass('no-more');
            else
                $('.follow-list .more').css('display', 'block');

            $('.follow-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}

function getFans() {
    var page = parseInt($('.fan-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/fans?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFans(data, $('.fan-list .fanItems'));

            if (data.data.length < 10)
                $('.fan-list .more').addClass('no-more');
            else
                $('.fan-list .more').css('display', 'block');

            $('.fan-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}

function getFavorites() {
    var page = parseInt($('.favorite-list').attr('page'));
    var id = $('input[name=personid]').val();
    if (!id)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: '/person/favorites?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            toFans(data, $('.fan-list .fanItems'));

            if (data.data.length < 10)
                $('.fan-list .more').addClass('no-more');
            else
                $('.fan-list .more').css('display', 'block');

            $('.fan-list').attr('page', page + 1);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}